import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Footer from "./Footer";
import HeadingNavbar from "./HeadingNavbar";
import Header from "./Header";
import { Helmet } from "react-helmet";

const FAQs = () => {
  return (
    <>
      <Helmet>
        <title>FAQs | Bliss Water Technology</title>
        <meta
          name="description"
          content="Find answers to frequently asked questions about product delivery, returns, payments, installation, and privacy at Bliss Water Technology."
        />
        <meta
          name="keywords"
          content="FAQs, RO filter delivery, installation service, return policy, payment method, privacy, water filters, Bliss Water Technology"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <HeadingNavbar />
      <Header />

      <Container>
        <Row className="my-md-5 my-4">
          <Col>
            <Card.Title className="text-center fs-2 mb-3 fw-bold">
              Frequently Asked Questions (FAQs)
            </Card.Title>
            <Card>
              <Card.Body className="mt-2">
                <Card.Text as="div">

                  <section>
                    <h5 className="fw-bold">1. What types of products do you offer?</h5>
                    <p>
                      We offer premium water purification products including RO filters, geysers, pumps,
                      membranes, and related accessories. All products are brand new and come with manufacturer warranties.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">2. Do you deliver and install products outside Gujarat?</h5>
                    <p>
                      No. Our delivery, installation, and service coverage is currently limited to Gujarat, India.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">3. How long does delivery take?</h5>
                    <p>
                      Most orders are delivered and installed within 5–7 business days of confirmation, depending on your location within Gujarat.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">4. Is shipping free?</h5>
                    <p>
                      Yes, free shipping is available for all orders above ₹500 within Gujarat. A small delivery charge may apply for lower-value orders, and it will be communicated beforehand.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">5. Do you offer installation services?</h5>
                    <p>
                      Yes, we provide professional installation for all our products. Our authorized technicians ensure proper fitting and setup at your location.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">6. What payment methods are accepted?</h5>
                    <p>
                      We do not accept online payments. All payments must be made directly to our delivery or installation personnel via cash, UPI, or digital methods at the time of service.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">7. Can I return a product if I’m not satisfied?</h5>
                    <p>
                      Yes. If you're not satisfied, you can return unused items in original packaging within 15 days of receipt. Returns are subject to inspection and approval.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">8. Do you accept exchanges?</h5>
                    <p>
                      We only accept exchanges for defective, damaged, or incorrect items. You must contact us immediately with proof for us to process your request.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">9. Are there any non-returnable items?</h5>
                    <p>
                      Yes. For hygiene and safety reasons, used water filters or opened consumable items cannot be returned or exchanged.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">10. Who pays for return shipping?</h5>
                    <p>
                      If the item is defective or incorrect, we cover return shipping. For other cases, return shipping is the customer’s responsibility.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">11. How do I schedule service or support?</h5>
                    <p>
                      You can contact our team by calling <a href="tel:+919265199516">+91 92651 99516</a> or emailing <a href="mailto:blisswatertechnology@gmail.com">blisswatertechnology@gmail.com</a> to schedule service or support appointments.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">12. Do you collect any personal data?</h5>
                    <p>
                      Yes, we collect basic information such as your name, phone number, and service location to coordinate deliveries and installations. We do not store or process online payments.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">13. Is my data secure?</h5>
                    <p>
                      We implement industry-standard security practices to protect your data. However, no system is 100% secure, and we encourage users to share only necessary information.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">14. Do you use cookies on your website?</h5>
                    <p>
                      Yes, our website uses cookies to improve your experience and analyze traffic. You can manage cookie preferences via your browser settings.
                    </p>
                  </section>

                  <section>
                    <h5 className="fw-bold">15. Can I update or delete my personal information?</h5>
                    <p>
                      Yes. You can contact us at any time to review, update, or delete your personal data.
                    </p>
                  </section>

                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default FAQs;
